
const LicenseAttachmentTypes =
{
    BusinessLicense: 79,
    ContractorLicense: 78,
};

export default LicenseAttachmentTypes;



// WEBPACK FOOTER //
// ./src/app/config/constants/LicenseAttachmentTypes.constant.js